<template>
  <div class="room-controls">
    <button
      class="mic-btn"
      :class="{ active: isActive }"
      @click="toggleMic"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path v-if="isActive" d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
        <path v-if="isActive" d="M19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8"/>
        <path v-else d="M1 1l22 22M15 9.34V4a3 3 0 0 0-6 0v5.34M12 19v4M8 23h8"/>
      </svg>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'VoiceRoomControls',
  computed: {
    ...mapState('voiceRoom', [
      'isHost',
      'isMuted',
    ]),
    isActive() {
      return !this.isMuted
    },
  },
  methods: {
    toggleMic() {
      if (this.isHost) {
        this.$emit('toggle-mic')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.room-controls {
  position: fixed;
  bottom: 100px;
  right: 20px;
  z-index: 1040;

  .mic-btn {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #2ECC71;
    border: none;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(46, 204, 113, 0.3);
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.05);
    }

    svg {
      width: 24px;
      height: 24px;
      stroke: currentColor;
    }

    &.active {
      background: #2ECC71;
    }

    &:not(.active) {
      background: #FF3B30;
      box-shadow: 0 4px 12px rgba(255, 59, 48, 0.3);
    }
  }
}

@media (max-width: 767.98px) {
  .room-controls {
    bottom: 90px;
    right: 15px;
  }
}
</style>
